module.exports = __webpack_public_path__ + "static/media/op_bank.b6be5d11.jpg";